import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// Mount from the site's authenticated route. Supply the current player's stable ID
// from its EXISTING auth context; this ID only namespaces local round recovery.
// Backend HttpOnly cookies remain the sole authentication/authorization mechanism.
export default function LuckyDuckyIncisor({ playerId, onBalance }) {
  const iframe = useRef(null);
  const navigate = useNavigate();
  const session = useCallback(() => {
    if (playerId) iframe.current?.contentWindow?.postMessage(
      { type: 'ld:session', playerId: String(playerId) }, window.location.origin,
    );
  }, [playerId]);
  useEffect(() => {
    function receive(event) {
      if (event.origin !== window.location.origin || event.source !== iframe.current?.contentWindow) return;
      if (event.data?.type === 'ld:ready') session();
      if (event.data?.type === 'ld:exit') navigate('/slots');
      if (event.data?.type === 'ld:balance' && Number.isFinite(event.data.balance_dollars)
          && event.data.balance_dollars >= 0) onBalance?.(event.data.balance_dollars);
    }
    window.addEventListener('message', receive);
    return () => window.removeEventListener('message', receive);
  }, [navigate, onBalance, session]);
  if (!playerId) return <p>Please sign in to play Lucky Ducky.</p>;
  return <iframe
    key={String(playerId)} ref={iframe} onLoad={session}
    src="/games/lucky-ducky-incisor/index.html"
    title="Lucky Ducky" allow="autoplay; fullscreen" allowFullScreen
    style={{ position: 'fixed', inset: 0, width: '100%', height: '100dvh', border: 0, background: '#061b35' }}
  />;
}
